import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LoginContext } from 'src/lib/LoginContext';
import { GlobalBanner } from './GlobalBanner';

const DISMISS_KEY = 'riac_bidder_banner_dismissed';
const DISMISS_DURATION_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

const isBidderBannerDismissed = (): boolean => {
  try {
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if(!dismissed) return false;
    return Date.now() - Number(dismissed) < DISMISS_DURATION_MS;
  } catch {
    return false;
  }
};

const dismissBidderBanner = () => {
  try {localStorage.setItem(DISMISS_KEY, String(Date.now()));} catch {/* */}
};

export const IncompleteRegistrationBanner = () => {
  const { isLoggedIn, canBid, canSell, registrationComplete } = useContext(LoginContext);
  const location = useLocation();
  const [dismissed, setDismissed] = useState(isBidderBannerDismissed);

  if(!ENABLE_NEW_REGISTRATION) return null;
  if(!isLoggedIn) return null;
  if(canBid) return null;
  if(location.pathname.startsWith('/register')) return null;

  // Incomplete registration — hasn't finished the registration flow
  if(!registrationComplete) {
    return (
      <GlobalBanner color='warning'>
        Your account registration is incomplete.{' '}
        <a href='/register' className='underline font-medium'>Complete registration</a>{' '}
        to start bidding.
      </GlobalBanner>
    );
  }

  // Registration complete but can't bid — seller-only account
  if(!canBid && canSell && !dismissed) {
    return (
      <GlobalBanner
        color='primary'
        onDismiss={() => {
          dismissBidderBanner();
          setDismissed(true);
        }}
      >
        Want to bid in our auctions?{' '}
        <a href='/account' className='underline font-medium'>Complete bidder verification</a>{' '}
        on your account page to get started.
      </GlobalBanner>
    );
  }

  return null;
};
